module.exports = __webpack_public_path__ + "static/media/vase-1.d18859ef.glb";